<template>
  <div class="asket">
    <section class="container section-1">
      <img
        class="client-logo"
        src="/static/images/clients/logos/asketBlack.svg"
        alt="Asket logo"
      />
      <div class="title">
        <h1>
          The Pursuit of Less
        </h1>
        <p>
          The world doesn’t need another fashion brand. Asket redefines how we
          consume fashion with a promise to restore the value of garments by
          creating meaningful essentials. A permanent collection of
          zero-compromise pieces, their stories uncovered and told.
        </p>
      </div>
      <img
        class="big"
        src="/static/images/cases/asket/asket_top_image.png"
        srcset="/static/images/cases/asket/asket_top_image2x.png 2x"
        alt="ipad screenshot"
      />
    </section>
    <section class="container section-2">
      <div class="ipads">
        <div class="left">
          <img
            src="/static/images/cases/asket/hero.png"
            srcset="/static/images/cases/asket/hero2x.png 2x"
            alt="ipads screenshots"
            v-scroll-reveal="{
              delay: 0,
              distance: '900px',
              duration: 2000,
              origin: 'bottom'
            }"
          />
          <img
            src="/static/images/cases/asket/product.png"
            srcset="/static/images/cases/asket/product2x.png 2x"
            alt="ipads screenshots"
            v-scroll-reveal="{
              delay: 200,
              distance: '900px',
              duration: 2000,
              origin: 'bottom'
            }"
          />
        </div>
        <div class="right">
          <img
            src="/static/images/cases/asket/products.png"
            srcset="/static/images/cases/asket/products2x.png 2x"
            alt="ipads screenshots"
            v-scroll-reveal="{
              delay: 100,
              distance: '900px',
              duration: 2000,
              origin: 'bottom'
            }"
          />
          <img
            src="/static/images/cases/asket/text.png"
            srcset="/static/images/cases/asket/text2x.png 2x"
            alt="ipads screenshots"
            v-scroll-reveal="{
              delay: 300,
              distance: '900px',
              duration: 2000,
              origin: 'bottom'
            }"
          />
        </div>
      </div>

      <div
        class="quarter"
        v-scroll-reveal="{ delay: 200, distance: '1000px', origin: 'right' }"
      >
        <h2>Transparency like never before</h2>
        <p>
          Identifying every unique process in the creation of a garment and the
          exact location of the farms, plants, factories and facilities is no
          easy task. Presenting the results should be.
        </p>
      </div>
    </section>
    <section class="container section-3">
      <div class="third center" v-scroll-reveal="{ delay: 200 }">
        <img src="/static/images/icons/bulb.svg" alt="" />
        <h3>Unleash your creativity</h3>
        <p>
          Enabling content managers to be truly creative.
        </p>
      </div>
      <div class="third center" v-scroll-reveal="{ delay: 400 }">
        <img src="/static/images/icons/dynamic.svg" alt="" />
        <h3>Dynamic Content</h3>
        <p>
          Share content across pages and products where necessary, or start with
          a blank canvas.
        </p>
      </div>
      <div class="third center" v-scroll-reveal="{ delay: 600 }">
        <img src="/static/images/icons/ai.svg" alt="" />
        <h3>Next generation</h3>
        <p>
          A bleeding edge tech-stack with best-in-class performance.
        </p>
      </div>
    </section>

    <section class="container section-5">
      <div
        class="half center"
        v-scroll-reveal="{ delay: 200, distance: '1000px', origin: 'right' }"
      >
        <h2>From idea to launch in three months</h2>
        <p>
          OMS, CMS and a re-imagined frontend all from scratch, while moving
          warehouses. In three months during vacations.
        </p>
      </div>
      <VideoHolder
        v-scroll-reveal="{
          delay: 0,
          distance: '1000px',
          duration: 2000,
          origin: 'left'
        }"
        source-mobile="https://player.vimeo.com/external/417641994.m3u8?s=12771a3de7614a820be989d12c0fb0bc58681d4a"
        source-desktop="https://player.vimeo.com/external/417990857.m3u8?s=055b47e038bcb9ecda8dc8cfbcd0f4ca6ccbeff6"
      />
    </section>
    <section class="next-project">
      <router-link to="/cases/happysocks">
        View next case →
      </router-link>
    </section>
    <StartProject />
    <Footer />
  </div>
</template>

<script>
import StartProject from "@/components/home/StartProject.vue";
import Footer from "@/components/Footer.vue";
import VideoHolder from "@/components/general/VideoHolder";

export default {
  name: "Asket",
  components: {
    VideoHolder,
    StartProject,
    Footer
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.asket {
  section {
    min-height: 100vh;
    display: flex;
    align-items: center;

    h2 {
      @include headline-medium;
    }
  }
  .section-1 {
    .title {
      position: sticky;
      top: 10vh;
      left: 5.3vw;
      width: 30vw;
      z-index: 2;
      h1 {
        @include headline-large;
        font-weight: 400;
      }
    }
    img.big {
      position: absolute;
      right: 13vw;
      top: -180px;
      z-index: 1;
    }
    .client-logo {
      position: fixed;
      right: 5.3vw;
      bottom: 5vh;
      width: 5vw;
      z-index: 2;
    }
  }
  .section-2 {
    //justify-content: center;
  }
  .section-3 {
    h3 {
      @include headline-small;
    }
    .third {
      text-align: center;
      img {
        height: 10vh;
        margin-bottom: 10vh;
        //opacity: 0.5;
      }
    }
  }
  .section-4 {
    display: none;
    justify-content: center;
    background: $black;
    img {
      display: inline-block;
      max-width: 50%;
      box-shadow: 5vw 5vh 100px rgba(black, 0.2);
      &:nth-child(2) {
        margin-top: 50vh;
      }
    }
  }
  .section-5 {
    flex-direction: column;
    justify-content: center;
    .half {
      text-align: center;
      padding-right: 0;
      padding-left: 0;
    }
  }
  .next-project {
    min-height: 20vh;
    justify-content: center;
    align-items: center;
    //border-bottom:1px solid rgba(white,0.1);
    a {
      @include headline-small;
    }
  }
  .ipads {
    display: flex;
    width: 50%;
    > div {
      flex: 0 0 50%;
      max-width: 444px;
      flex-shrink: 1;
      img {
        max-width: 100%;
      }
    }
    .left {
      margin-top: -190px;
    }
  }
  .ipads {
    padding-right: 5%;
  }
}
@media (max-width: $tablet) {
  .asket {
    section {
      width: 100vw;
      overflow: hidden;
    }
    .section-1 {
      img.big {
        right: 0;
        top: -180px;
      }
    }
    .section-2 {
      margin-top: 220px;
    }

    .ipads {
      //padding-right: 0;
      width: 70%;
      > div {
        //max-width: 222px;
      }
      .left {
        margin-top: -190px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
@media (max-width: $mobile) {
  .asket {
    section {
      min-height: 100vh;
      display: block;
    }
    .section-1,
    .section-2,
    .section-3,
    .section-4,
    .section-5 {
      img.big {
        position: relative;
        max-width: 100vw;
        margin: 0 -30px;
        height: 700px;
        object-fit: cover;
        right: 0;
      }
    }
    .section-1 {
      .title {
        position: relative;
        top: 0;
        left: 0;
        text-align: center;
        width: 100%;
        padding: 50px 30px;
      }
      img.big {
        top: -10px;
      }
      .client-logo {
        width: 15vw;
      }
    }
    .section-2 {
      display: flex;
      flex-direction: column;
      text-align: center;
      margin-top: unset;
      padding-top: 5vh;
      .ipads {
        order: 2;
        max-width: 100%;
        width: 100%;
        padding-right: 0;
        padding: 10%;
        margin-right: unset;
        > div {
          max-width: unset;
        }
        .left {
          margin-top: unset;
        }
        img {
          max-width: 100%;
        }
      }
      .quarter {
        order: 1;
        width: 100%;
        padding-right: 0;
      }
    }
    .section-3 {
      .third {
        width: 100%;
        margin-bottom: 100px;
      }
    }
    .section-4 {
      display: none;
    }
    .section-5 {
      .half {
        width: 100%;
      }
      img.big {
        height: 300px;
      }
    }
    .next-project {
      text-align: center;
    }
  }
}
</style>
